import {translatePrj} from "../classes/vue-dict-filter";

const CONFIGTYPE_LIEFERART = "Lieferart";

export class VersandAufteilungService {
    constructor(configuratorService) {
        this.configuratorService = configuratorService
    }

    validate(body) {
        const url = `/api/${window.languagepath}/prj/product/split_dispatch`;

        return fetch(url, {
            method: "POST", body: JSON.stringify(body)
        }).then((response) => response.json())
    }

    addresses() {
        return this.configuratorService.byConfigoptionType(CONFIGTYPE_LIEFERART).dynamicValues.versandaufteilung
    }

    setAddress(addresses) {
        this.configuratorService.byConfigoptionType(CONFIGTYPE_LIEFERART).dynamicValues.versandaufteilung = addresses;
    }

    addEmptyAddress() {
        // corresponds to the serialized object of SerializableVersandaufteilung.java
        this.configuratorService.byConfigoptionType(CONFIGTYPE_LIEFERART).dynamicValues.versandaufteilung.push({
            quantity: 0,
            addressinfoid: -1,
            deliveryaddress:null,
        });
    }

    removeAddress(index) {
        this.configuratorService.byConfigoptionType(CONFIGTYPE_LIEFERART).dynamicValues.versandaufteilung.splice(index, 1)
    }

    updateQuantity(address, quantiy) {
        // making sure its a number
        address.quantity = Math.abs(parseInt(quantiy)) || 0;
    }

    getConcatenatedAddress (address, delimiter) {
        const a = address.deliveryaddress

        if (a) {
            const nameLine = [a.salutation, a.firstname, a.lastname].filter(v => v).join(" ")
            const zipLine = [a.myZip, a.city].filter(v => v).join(" ")
            return [a.company, a.department, nameLine, a.addressLine1, zipLine]
                .filter(v => v).join(delimiter)
        }

        return translatePrj("versandaufteilungDeliveryAddress")
    }
}